import React from "react";
import { Typography, Button, Card, CardActions, CardContent, CardMedia, Box, } from "@mui/material";
import styles from "./styles";
var CartItem = function (_a) {
    var item = _a.item, onUpdateCartQty = _a.onUpdateCartQty, onRemoveFromCart = _a.onRemoveFromCart;
    return (React.createElement(Card, null,
        React.createElement(CardMedia, { component: "img", sx: styles.media, image: item.image.url, alt: item.name }),
        React.createElement(CardContent, { sx: styles.cardContent },
            React.createElement(Typography, { variant: "h4" }, item.name),
            React.createElement(Typography, { variant: "h5" }, item.line_total.formatted_with_symbol)),
        React.createElement(CardActions, { sx: styles.cartActions },
            React.createElement(Box, { sx: styles.buttons },
                React.createElement(Button, { type: "button", size: "small", onClick: function () { return onUpdateCartQty(item.id, item.quantity - 1); } }, "-"),
                React.createElement(Typography, null, item.quantity),
                React.createElement(Button, { type: "button", size: "small", onClick: function () { return onUpdateCartQty(item.id, item.quantity + 1); } }, "+")),
            React.createElement(Button, { variant: "contained", type: "button", color: "secondary", onClick: function () { return onRemoveFromCart(item.id); } }, "Remove"))));
};
export default CartItem;
